
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/[state]",
      function () {
        return require("private-next-pages/play/[state]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/[state]"])
      });
    }
  